module.exports = __webpack_public_path__ + "front/img/p3.a37180ee.png";